var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgSz(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7303_38352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8093 17.2174C23.5721 15.6398 24 13.8698 24 12C24 10.1302 23.5721 8.3602 22.8093 6.78262L12 6.26086L1.19072 6.78258C0.427875 8.3602 0 10.1302 0 12C0 13.8698 0.427875 15.6398 1.19072 17.2174L12 17.7391L22.8093 17.2174Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0C7.24242 0 3.13167 2.76867 1.19067 6.78262H22.8092C20.8682 2.76867 16.7574 0 12 0V0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 24C7.24242 24 3.13167 21.2313 1.19067 17.2174H22.8092C20.8682 21.2313 16.7574 24 12 24V24Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4333 8.34782H0.566672C0.199078 9.4995 0 10.7264 0 12C0 13.2735 0.199078 14.5005 0.566672 15.6522H23.4333C23.8009 14.5005 24 13.2735 24 12C24 10.7264 23.8009 9.4995 23.4333 8.34782Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.17383 11.4783H19.826V12.5218H4.17383V11.4783Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26074 9.39131H17.739V10.4348H6.26074V9.39131Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8138 12C17.8138 12 15.1305 15.1305 12.0001 15.1305C8.86968 15.1305 8.86963 12 8.86963 12C8.86963 12 8.86963 8.86954 12.0001 8.86954C15.1305 8.86954 17.8138 12 17.8138 12Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 15.1305C8.8695 15.1305 6.18628 12 6.18628 12C6.18628 12 8.8695 8.86954 12 8.86954",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.91309 10.9565H10.9566V13.0435H9.91309V10.9565Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0435 10.9565H14.0869V13.0435H13.0435V10.9565Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.17386 13.0435C4.75016 13.0435 5.21734 12.5763 5.21734 12C5.21734 11.4237 4.75016 10.9565 4.17386 10.9565C3.59756 10.9565 3.13037 11.4237 3.13037 12C3.13037 12.5763 3.59756 13.0435 4.17386 13.0435Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.826 13.0435C20.4023 13.0435 20.8694 12.5763 20.8694 12C20.8694 11.4237 20.4023 10.9565 19.826 10.9565C19.2497 10.9565 18.7825 11.4237 18.7825 12C18.7825 12.5763 19.2497 13.0435 19.826 13.0435Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7303_38352"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSz);
export default __webpack_public_path__ + "static/media/sz.94059f11d4ba6336cddddec842c574a0.svg";
export { ForwardRef as ReactComponent };